<script>
  import { afterUpdate } from 'svelte'
	import { map, filter, find, isEmpty } from 'lodash'
  import Input from '../elements/Input.svelte'
  import Label from '../elements/Label.svelte'
  import Blink from '../elements/Blink.svelte'
  
  export let loading_state // expects loading state store
  export let list_items
  export let label= ''
  export let entered_name = ''
  export let required = true
  export let disabled = false

  let highlighted_index = -1
  let highlighted_el
  
  let prepared_list
  let filtered_list
  let list_el
  let list_visible = false
  $: if (filtered_list.length === 0) list_visible = false;

  function prepareList() {
    prepared_list = map(list_items, (item) => {let obj = {'name':item, 'selected':false, 'highlighted':false}; return obj})
    filtered_list = filter(prepared_list, item => item.name?.toLowerCase().includes(entered_name.toLowerCase()))
  }

  function showList() {
    if (filtered_list.length > 0) list_visible = true
  }
  
  function hideList() {
    list_visible = false
  }
  
  function selectItem(index) {
    deselectSelectedItem()
    filtered_list[index].selected = true
    entered_name = filtered_list[index].name
    hideList()
  }
  function deselectSelectedItem() {
    let item = find(filtered_list, 'selected')
    if (item) item.selected = false
    filtered_list = filtered_list
  }

  function highlightItem(index) {
    dehighlightHighlighted()
    highlighted_el = list_el.childNodes[index]
    highlighted_index = index
    filtered_list[index].highlighted = true
  }

  function advanceHighlighted(direction) {
    if (isEmpty(filtered_list)) return

    let new_index = highlighted_index + direction;
    if (new_index < 0) {
      new_index = filtered_list.length - 1
    } else if (new_index >= filtered_list.length) {
      new_index = 0
    }
    highlightItem(new_index)
  }

  function dehighlightHighlighted() {
    let item = find(filtered_list, 'highlighted')
    if (item) item.highlighted = false
    highlighted_index = -1
    filtered_list = filtered_list
  }

  function handleKeydown(e) {
    if (!list_visible && e.key === 'Enter') return
    if (!list_visible) showList()

    if (e.key === 'Enter') {
      if (highlighted_el) {
        selectItem(highlighted_index)
      }
      hideList()
      e.preventDefault()
    } else if (e.key === 'Tab') {
      list_visible = false
    } else if (e.key === 'ArrowDown') {
      advanceHighlighted(1)
    } else if (e.key === 'ArrowUp') {
      advanceHighlighted(-1)
    } else {
      dehighlightHighlighted()
    }
  }

  afterUpdate(() => {
    if (highlighted_el) highlighted_el.scrollIntoView({block: 'nearest'})
  })

  $: list_items && prepareList()
  $: filtered_list = filter(prepared_list, item => item.name?.toLowerCase().includes(entered_name.toLowerCase()))
</script>

<div class="selectList">
  <Label name="selectList" >{label}</Label>

  <Input 
    type="text"
    name="selectList"
    focused={true}
    required={required}
    disabled={disabled}
    bind:value={entered_name}
    on:focus={showList}
    on:blur={hideList}
    on:keydown={handleKeydown}
    />

  {#if loading_state?.loading}
    <p class="loading">
      <Blink>Loading list items...</Blink>
    </p>
  {/if}
  {#if loading_state?.error}
    <p class="error">
      There was an error loading the list
    </p>
  {/if}

  {#if list_visible}
    <ul class="list" bind:this={list_el}>
      {#each filtered_list as item, index}
        <li 
        on:mousedown={() => selectItem(index)}
        class:selected={item.selected}
        class:highlighted={item.highlighted}>
          {item.name}
        </li>
      {/each}
    </ul>
  {/if}
</div>

<style>
  .selectList {
    position: relative;
    z-index: 1;
  }
  ul.list {
    padding-top: 1rem;
    position: absolute;
    width: 100%;
    max-height: 20rem;
    overflow-y: scroll;
    background-color: var(--c-content-bg);
    border: 1px solid var(--c-nav-bg);
    border-top-width: 0;
    box-shadow: var(--box-shadow);
  }
  ul.list li {
    position: relative;
    padding: 0.5rem 1rem;
    cursor: pointer;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
  }
  ul.list li:first-of-type {
    margin-top: 0.5rem;
  }
  ul.list li:last-of-type {
    margin-bottom: 0.5rem;
  }
  ul.list li.highlighted,
  ul.list li:hover {
    color: var(--c-accent);
    background-color: var(--c-nav-bg);
    border-left-color:var(--c-content-bg);
    border-right-color:var(--c-content-bg);
  }
  ul.list li.selected {
    color: var(--c-accent);
  }
  ul.list li.selected:before {
    position: absolute;
    top: 1.1rem;
    right: 1rem;
    width: 1rem;
    height: 0.6rem;
    border-top: 2px solid var(--c-accent);
    border-right: 2px solid var(--c-accent);
    transform: rotate(135deg);
    content:"";
  }
  .loading {
    margin-top: 0.5rem;
    color: var(--c-text-faded);
  }
  .error {
    margin-top: 0.5rem;
    color: var(--c-danger);
  }
</style>